import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';

export type CompanyUser = {
  uid: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  level: number;
};

export const companyAdminListUsers = async (payload: { companyId: string }) => {
  const fn = httpsCallable<typeof payload, { users: CompanyUser[]; requesterLevel: number; companyId: string }>(
    functions,
    'company_admin_list_users'
  );
  const res = await fn(payload);
  return (res.data as any).data ?? res.data;
};

export const companyAdminSetUserLevel = async (payload: { companyId: string; uid: string; level: number }) => {
  const fn = httpsCallable<typeof payload, null>(functions, 'company_admin_set_user_level');
  await fn(payload);
};

export const companyAdminCreateUser = async (payload: {
  companyId: string;
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
  level: number;
}) => {
  const fn = httpsCallable<typeof payload, { uid: string }>(functions, 'company_admin_create_user');
  const res = await fn(payload);
  return (res.data as any).data ?? res.data;
};
